import React from 'react'
import { Redirect } from 'react-router-dom'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import access from '../../../../utils/access'

import styleA from './style'
import styleB from '../../style'

import Container from '../../partials/Container'
import UserTable from '../../partials/UserTable'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('User', 'Auth', 'Config')
@observer
export class User extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      active: {},
      editor: {
        search: {
          active: false,
          value: ''
        }
      }
    }
  }

  componentWillMount () {
    const _searchUsersLoop = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending) {
          return _searchUsersLoop()
        }

        if (
          !this.props.User.me.pending &&
          access.supportAgent(this.props.User.me.permissions || {})
        ) {
          this.props.User.getAllUsers()
        }
      }, 500)
    }

    _searchUsersLoop()
  }

  onEditClick () {
    if (this.state.active.id) {
      return this.props.history.push(
        `${this.props.location.pathname}/${this.state.active.id}`
      )
    }

    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        enabled: !this.state.editor.enabled
      }
    })
  }

  onUserClick (e) {
    const userId = e.currentTarget.dataset.userid

    if (this.state.editor.enabled || this.state.editor.search.active) {
      return this.props.history.push(
        `${this.props.location.pathname}/${userId}`
      )
    }

    this.setState({
      ...this.state,
      active: {
        ...this.state.active,
        id: userId
      }
    })
  }

  onSearchClick (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        search: {
          ...this.state.editor.search,
          active: true
        }
      }
    })
  }

  onInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        search: {
          ...this.state.editor.search,
          value: e.target.value
        }
      }
    })
  }

  onSearchSubmit (e) {
    e.preventDefault()

    this.props.User.searchUsers(this.state.editor.search.value)
  }

  render () {
    if (
      !this.props.User.me.pending &&
      !access.modUser(this.props.User.me.permissions || {})
    ) {
      return <Redirect to={`/dashboard/user/${this.props.User.me.id}`} />
    }

    return (
      <Container
        {...this.props}
        hide={!access.modUser(this.props.User.me.permissions || {})}
      >
        <Row>
          <Col xs='12' lg='6'>
            <h2 className={css(styleB.headers.h2)}>
              {this.state.editor.search.active ? `Search Member` : `Members`}
            </h2>
          </Col>
          <Col
            style={{
              overflow: `hidden`,
              position: `relative`,
              transition: `0.2s`
            }}
          >
            {/* { this.state.editor.search.active ? ( */}
            <SearchArea
              theme={THEME_LIST[this.props.Config.theme]}
              style={{
                transition: `0.2s`,
                width: `100%`,
                position: `absolute`,
                ...(this.state.editor.search.active
                  ? {
                    top: 0,
                    left: `15px`
                  }
                  : {
                    top: `-100px`,
                    left: `15px`
                  })
              }}
              onSubmit={this.onSearchSubmit.bind(this)}
              onInputChange={this.onInputChange.bind(this)}
              editor={this.state.editor}
            />
            <NavigationArea
              style={{
                transition: `0.2s`,
                width: `100%`,
                position: `absolute`,

                ...(!this.state.editor.search.active
                  ? {
                    top: 0,
                    left: `15px`
                  }
                  : {
                    top: `100px`,
                    left: `15px`
                  })
              }}
              editor={this.state.editor}
              onEditClick={this.onEditClick.bind(this)}
              onSearchClick={this.onSearchClick.bind(this)}
            />
          </Col>
        </Row>
        <Row>
          <UserTable
            users={
              this.state.editor.search.active
                ? this.props.User.search.slice()
                : this.props.User.all.slice()
            }
            theme={THEME_LIST[this.props.Config.theme]}
            activeId={this.state.active.id}
            onUserClick={this.onUserClick.bind(this)}
          />
        </Row>
      </Container>
    )
  }
}

const SearchArea = props => {
  return (
    <form
      onSubmit={props.onSubmit}
      style={props.style || {}}
      className={`row ${css(
        styleA.search.container,
        styleA[props.theme.name]
          ? styleA[props.theme.name].search.container
          : null
      )}`}
    >
      <Col className={css(styleA.search.inputWrapper)}>
        <input
          type={`text`}
          name={`search`}
          placeholder={`search...`}
          value={props.editor.search.value}
          onChange={props.onInputChange}
          className={css(
            styleA.search.input,
            styleA[props.theme.name]
              ? styleA[props.theme.name].search.input
              : null
          )}
        />
      </Col>
      <Col xs='4' className={css(styleA.search.inputWrapper)}>
        <button
          className={css(
            styleB.buttons.button,
            styleB.buttons.red,
            styleA.search.button
          )}
        >
          Search
        </button>
      </Col>
    </form>
  )
}

const NavigationArea = props => {
  return (
    <Row style={props.style || {}}>
      <Col>
        <span
          className={css(
            styleB.buttons.button,
            styleB.buttons.red,
            props.editor.enabled ? styleB.buttons.redActive : null
          )}
          onClick={props.onEditClick}
        >
          Edit
        </span>
      </Col>
      <Col>
        <span
          className={css(styleB.buttons.button, styleB.buttons.red)}
          onClick={props.onSearchClick}
        >
          Search
        </span>
      </Col>
    </Row>
  )
}

export default User



// WEBPACK FOOTER //
// ./src/components/User/User/Main/index.js